import { Component, Host, h } from "@stencil/core";

@Component({
  tag: "ls-status-history",
  styleUrl: "ls-status-history.css",
  shadow: true,
})
export class LsStatusHistory {
  render() {
    return (
      <Host>
        <fieldset>
          <legend>ls-status-history</legend>
        </fieldset>
        <slot></slot>
      </Host>
    );
  }
}
